module.exports = __webpack_public_path__ + "img/logistics.ce36a17e.jpg";